import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import { Menu, MenuList, MenuButton, MenuLink } from 'components/_new/ui/Menu'

import HeaderSubNavItemTitle from '../../HeaderSubNavItemTitle/HeaderSubNavItemTitle'
import HeaderSubNavDropdown from '../HeaderSubNavDropdown/HeaderSubNavDropdown'

import s from './HeaderSubNavItem.scss'


class HeaderSubNavItem extends PureComponent {

  static propTypes = {
    title: PropTypes.object.isRequired,
    linkId: PropTypes.string,
    to: PropTypes.string,
    toOLD: PropTypes.string,
    onClick: PropTypes.func,
    subNav: PropTypes.arrayOf(PropTypes.object),
    dropdown: PropTypes.array,
    dataTestId: PropTypes.string,
  }

  render() {
    const { subNav, dropdown, linkId, title, to, toOLD,
      isDesktopDropdownEnabled, dataTestId, isBig, onClick } = this.props

    const hasSubMenu = Boolean(subNav)
    const hasDropdown = isDesktopDropdownEnabled && Boolean(dropdown)

    const rootClassName = cx(s.navItem, {
      [s.withDropdown]: isDesktopDropdownEnabled,
    })

    if (hasDropdown) {
      return (
        <Menu toggleOnHover fullWidth>
          <MenuButton
            className={rootClassName}
            id={linkId}
            dataTestId={dataTestId}
            onClick={onClick}
            role="menuitem"
          >
            <HeaderSubNavItemTitle
              className={s.title}
              linkId={linkId}
              {...{ title, to, toOLD }}
            />
          </MenuButton>
          <MenuList>
            <HeaderSubNavDropdown
              items={dropdown}
            />
          </MenuList>
        </Menu>
      )
    }

    if (hasSubMenu) {
      const menuListClass = cx(s.subNav, {
        [s.big]: isBig,
      })

      const line = <div className={s.line} role="none" />

      return (
        <Menu toggleOnHover>
          <MenuButton onClick={onClick} className={rootClassName} dataTestId={dataTestId} role="menuitem">
            <HeaderSubNavItemTitle
              className={s.title}
              linkId={linkId}
              {...{ title, to, toOLD }}
            />
          </MenuButton>
          <MenuList className={menuListClass}>
            {
              subNav
                .map(({ title, to, toOLD, linkId, bold, onClick, dataTestId, isLine }, index) => (
                  <MenuLink
                    key={index}
                    className={s.subItem}
                    containerClassName={cx({ [s.subItemContainer]: isBig && !bold && !isLine })}
                    customElement={isLine && line}
                    id={linkId}
                    customColor
                    {...{ title, to, toOLD, bold, onClick, dataTestId }}
                  />
                ))
            }
          </MenuList>
        </Menu>
      )
    }

    return (
      <div className={rootClassName} id={linkId} data-testid={dataTestId} role="none">
        <HeaderSubNavItemTitle className={s.title} role="menuitem" {...{ title, to, toOLD, onClick, linkId }} />
      </div>
    )
  }
}


export default HeaderSubNavItem
